import { render, staticRenderFns } from "./loginforprovider.vue?vue&type=template&id=4b058544&scoped=true&"
import script from "./loginforprovider.vue?vue&type=script&lang=js&"
export * from "./loginforprovider.vue?vue&type=script&lang=js&"
import style0 from "./loginforprovider.vue?vue&type=style&index=0&id=4b058544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b058544",
  null
  
)

export default component.exports